var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlusIcon = function SvgPlusIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa6-solid:plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.09961 2.60059C9.09961 2.04746 8.65273 1.60059 8.09961 1.60059C7.54648 1.60059 7.09961 2.04746 7.09961 2.60059V7.10059H2.59961C2.04648 7.10059 1.59961 7.54746 1.59961 8.10059C1.59961 8.65371 2.04648 9.10059 2.59961 9.10059H7.09961V13.6006C7.09961 14.1537 7.54648 14.6006 8.09961 14.6006C8.65273 14.6006 9.09961 14.1537 9.09961 13.6006V9.10059H13.5996C14.1527 9.10059 14.5996 8.65371 14.5996 8.10059C14.5996 7.54746 14.1527 7.10059 13.5996 7.10059H9.09961V2.60059Z",
    fill: "#828282"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlusIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "plus-icon.6f593f94a985deb392c4c8a234e2943a.svg";